export enum RelativeRelationshipCode {
    SPOUSE = 'CY',
    SON = 'HJ',
    FATHER = 'PD',
    BROTHER = 'HR',
    RELATED = 'AL',
}
